import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import styled from 'styled-components';

export const TooltipContainerStyled = styled.div`
  width: fit-content;
  display: inline-flex;
`;

export const TooltipContentStyled = styled(TooltipPrimitive.Content)`
  width: max-content;
  max-width: 250px;
  position: relative;
  overflow: visible;
  z-index: 1400;
  background: ${(p) => p.theme.colors.neutral.onContainer};
  border-radius: 3px;
  ${(p) => p.theme.shadow.primary[16]};
  color: ${(p) => p.theme.colors.neutral.background};
  pointer-events: none;
  animation-duration: 0.2s;
  animation-timing-function: ease-out;

  &[data-state='delayed-open'] {
    animation-name: fadeIn;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const TooltipTitleStyled = styled.div`
  ${(p) => p.theme.typography.body4};
  padding: 5px 12px;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: normal;
  text-transform: none;
`;

export const TooltipArrowStyled = styled.svg`
  display: block;
  width: 16px;
  height: 6px;
  color: ${(p) => p.theme.colors.neutral.onContainer};
  transform: rotate(180deg);
  transform-origin: center;

  path {
    fill: currentColor;
  }
`;
